import { useCallback } from 'react';

import { Checkbox } from '@farmersdog/corgi-x';

import styles from './CheckboxInput.module.css';

import type { TOSAComponentInput, TOSALeafNode } from '../../../types';
import type { ChangeEvent } from 'react';

export const CheckboxInput = (props: TOSAComponentInput<TOSALeafNode>) => {
  const { node, formMethods } = props;
  const { getValues, register, setValue } = formMethods;
  const value = getValues(node.name);
  const registerProps = register(node.name);

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      e.persist();
      setValue(node.name, e.target.checked, { shouldValidate: true });
    },
    [node.name, setValue]
  );

  return (
    <>
      {node.input?.label}{' '}
      <Checkbox
        {...registerProps}
        className={styles.checkbox}
        id={node.__self__}
        name={node.name}
        checked={value as boolean}
        onChange={handleChange}
      />
    </>
  );
};
